import $ from 'jquery';

export default function googleMaps (vars){

    var $map = $('.js-map');
    var map;

    if ($map.length) {

        google.maps.event.addDomListener(window, 'load', init);

        var defaultOptions = {
                center: 'new google.maps.LatLng(50.26493001103694,-5.09316086769104)',
                zoom: 15,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.DEFAULT,
                },
                disableDoubleClickZoom: true,
                mapTypeControl: false,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                },
                scaleControl: false,
                scrollwheel: false,
                panControl: true,
                streetViewControl: true,
                draggable : false,
                overviewMapControl: false,
                overviewMapControlOptions: {
                    opened: false,
                },
                mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        function init() {
            $( $map ).each( function( index, element ){
                var mapOptions = $.extend({}, defaultOptions);
                    mapOptions.center = new google.maps.LatLng($(this).data('lat'), $(this).data('lng'));
                var map = new google.maps.Map(element, mapOptions);
                var marker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng($(this).data('lat'), $(this).data('lng')),
                    icon: '/assets/img/map-marker.png',
                    title: $(this).data('map-title')
                });
            });
        }
    }
}